import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { computed, defineComponent, onMounted, reactive, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import apis from "@/api";
import dayjs from 'dayjs';
import common from "../../composables/common";
import SrcAudit from "../../components/SrcAudit";
export default defineComponent({
  name: 'TableTab',
  components: {
    SrcAudit
  },
  props: {
    activeTab: {
      default: ''
    }
  },
  setup(props, ctx) {
    const {
      initUserInfo,
      commonData,
      smsAuditRoles
    } = common();
    const router = useRouter(); // 路由跳转
    let data = reactive({
      isMyAudit: 0,
      auditDialogShow: false,
      auditRole: {},
      auditSmss: [],
      multiSmss: [],
      tableHeight: window.innerHeight - 300,
      loading: false,
      checkedDemands: [],
      paginationObj: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      queryParam: {
        name: "",
        state: '',
        createrId: "",
        date: "",
        status: "",
        createrName: "",
        orderBy: 'aa.BEGIN_TIME desc'
      },
      tableData: [],
      canApprCnt: 0
    });
    const handleSortChange = ({
      column,
      prop,
      order
    }) => {
      if (order) {
        switch (prop) {
          case 'planFinishDate':
            prop = 'aa.BEGIN_TIME';
            break;
          case 'optTime':
            prop = 'aa.OPT_TIME';
            break;
        }
        switch (order) {
          case 'descending':
            data.queryParam.orderBy = `${prop} desc`;
            break;
          case 'ascending':
            data.queryParam.orderBy = `${prop} asc`;
            break;
        }
      } else {
        data.queryParam.orderBy = 'aa.BEGIN_TIME desc';
      }
      loadData();
    };
    const handleSizeChange = val => {
      console.log(`每页 ${val} 条`);
      data.paginationObj.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      console.log(`当前页: ${val}`);
      data.paginationObj.pageNo = val;
      loadData();
    };
    const loadData = () => {
      data.loading = true;
      let params = data.queryParam;
      if (props.activeTab != 'all') {
        params.type = parseInt(props.activeTab);
      }
      if (data.queryParam.date) {
        // params.validDateBgn = dayjs(data.queryParam.date[0]).add(8, 'hour').format('YYYY-MM-DD 00:00:00')
        // params.validDateEnd = dayjs(data.queryParam.date[1]).add(8, 'hour').format('YYYY-MM-DD 23:59:59')
        params.beginTime = dayjs(data.queryParam.date).add(8, 'hour').format('YYYY-MM-DD');
      }
      apis.queryDemandPage({
        ...params,
        ...data.paginationObj
      }).then(res => {
        if (res.success) {
          var _res$data;
          const {
            records,
            size,
            total,
            current
          } = (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : res.data = {};
          data.tableData = records !== null && records !== void 0 ? records : [];
          data.paginationObj = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {
        ctx.emit("asideRefresh");
        data.loading = false;
      });
    };
    const showDetail = row => {
      switch (row.type) {
        case 0:
          router.push({
            path: '/my-needs/detail',
            query: {
              demandId: row.id
            }
          });
          break;
        case 1:
          // 短信需求
          router.push({
            path: '/my-needs/detailSms',
            query: {
              demandId: row.id
            }
          });
          break;
        case 2:
          router.push({
            path: '/my-needs/advertisDetail',
            query: {
              demandId: row.id
            }
          });
          break;
        case 3:
          router.push({
            path: '/my-needs/finishedDetail',
            query: {
              demandId: row.id
            }
          });
          break;
        case 4:
          router.push({
            path: '/my-needs/detailPrinted',
            query: {
              demandId: row.id
            }
          });
          break;
      }
    };
    const showEdit = (row, editType) => {
      switch (row.type) {
        case 0:
          router.push({
            name: 'demand-add',
            query: {
              demandId: row.id
            }
          });
          break;
        case 1:
          // 短信需求
          router.push({
            name: 'demand-addSms',
            query: {
              demandId: row.id,
              editType
            }
          });
          break;
        case 2:
          router.push({
            name: 'advertise-add',
            query: {
              demandId: row.id
            }
          });
          break;
      }
    };
    const submitForm = () => {
      loadData();
    };
    const resetForm = () => {
      // this.$refs[formName].resetFields();
    };
    const showAdd = () => {
      router.push('/my-needs/add');
    };
    const handleState = (row, state) => {
      console.log('row: ', row);
      if (state == 3) {
        // 校验需求是否可以进行完成操作
        apis.checkDemandCanFinish({
          demandId: row.id
        }).then(res => {
          if (res.success) {
            apis.updateStateById({
              id: row.id,
              state
            }).then(res => {
              if (res.success) {
                loadData();
                ElMessage.success('需求修改成功');
              } else {
                ElMessage.error(res.msg);
              }
            });
          } else {
            ElMessage.error(res.msg);
          }
        });
      } else {
        apis.updateStateById({
          id: row.id,
          state
        }).then(res => {
          if (res.success) {
            loadData();
            ElMessage.success('需求修改成功');
          } else {
            ElMessage.error(res.msg);
          }
        });
      }
    };
    const showAuditDialog = (auditRole, row) => {
      data.auditRole = auditRole;
      data.auditSmss = [];
      if (row) {
        data.auditSmss.push(row);
      } else if (data.multiSmss.length > 0) {
        data.auditSmss = data.multiSmss;
      } else {
        ElMessage.error('请选择要审批的素材');
        return;
      }
      data.auditSmss.forEach(a => {
        a.srcTyp = '7';
        a.multiSms = true;
      });
      data.auditDialogShow = true;
    };
    const stateSelectChange = () => {
      loadData();
    };
    const getCanApprCnt = computed(() => {
      let canApprCnt = 0;
      data.tableData.forEach(t => {
        if (selectable(t)) {
          canApprCnt += 1;
        }
      });
      return canApprCnt;
    });
    const getDemandType = type => {
      let typeName = '';
      switch (type) {
        case 0:
          typeName = '互联网物料需求';
          break;
        case 1:
          typeName = '短信需求';
          break;
        case 2:
          typeName = '宣传物料需求';
          break;
        case 3:
          typeName = '成品物料需求';
          break;
        case 4:
          typeName = '印刷品需求';
          break;
      }
      return typeName;
    };
    const selectable = (row, index) => {
      const apprers = row.srcApprUsers;
      if (apprers) {
        for (var i = 0; i < apprers.length; i++) {
          if (apprers[i].approveId == commonData.userInfo.userId) {
            return true;
          }
        }
        return false;
      } else {
        return false;
      }
    };
    const handleMyAuditQuery = () => {
      data.queryParam.isMyAudit = data.isMyAudit ? 1 : 0;
      loadData();
    };
    onMounted(() => {
      loadData();
      initUserInfo();
    });
    return {
      ...toRefs(data),
      ...toRefs(commonData),
      showDetail,
      showEdit,
      handleCurrentChange,
      handleSizeChange,
      loadData,
      submitForm,
      resetForm,
      showAdd,
      handleState,
      stateSelectChange,
      smsAuditRoles,
      showAuditDialog,
      selectable,
      getCanApprCnt,
      getDemandType,
      handleMyAuditQuery,
      handleSortChange
    };
  }
});